/** Wires useTaskListBaseKeyboard from controller-owned state. */
import { useTaskListBaseKeyboard } from './useTaskListBaseKeyboard';

export function useTaskListBaseControllerKeyboard({
  tasks,
  shared,
  selectSingleTask,
  deselectAllTasks,
  newTask,
  onStartEditing,
  editingTaskId,
  view,
  planMode,
  disableStructuralNav,
  disableRowNavigate,
  selectedTaskIds,
  handleStartAddingSubtask,
  addingSubtaskTo,
}) {
  return useTaskListBaseKeyboard({
    tasks,
    allTasks: shared.allTasks,
    selectedIndex: shared.selectedIndex,
    selectSingleTask,
    deselectAllTasks,
    openNewTaskInput: newTask.openNewTaskInput,
    handleToggleComplete: shared.handleToggleComplete,
    handleDeleteTask: shared.handleDeleteTask,
    updateTask: shared.updateTask,
    triggerFollowUp: shared.triggerFollowUp,
    handleStartFocus: shared.handleStartFocus,
    stopFocus: shared.stopFocus,
    activeFocusTaskId: shared.activeFocusTaskId,
    user: shared.user,
    onStartEditing,
    editingTaskId,
    isFocused: shared.isFocused,
    view,
    planMode,
    newTaskPosition: newTask.newTaskPosition,
    disableStructuralNav,
    disableRowNavigate,
    selectedTaskIds,
    cancel: newTask.cancel,
    handleStartAddingSubtask,
    addingSubtaskTo,
  });
}
